import { FC, SVGProps } from 'react';

export const UsersFilled: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
		<path
			d="M7.67545 11.1725C10.1968 11.1725 12.3519 11.5546 12.3519 13.0808C12.3519 14.607 10.2112 15 7.67545 15C5.15338 15 2.99902 14.6214 2.99902 13.0945C2.99902 11.5675 5.13902 11.1725 7.67545 11.1725Z"
			fill="currentColor"
			stroke="currentColor"
			strokeWidth="1.40501"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.67551 8.99419C6.0201 8.99419 4.67773 7.6525 4.67773 5.99709C4.67773 4.34169 6.0201 3 7.67551 3C9.33024 3 10.6726 4.34169 10.6726 5.99709C10.6788 7.64635 9.34596 8.98804 7.6967 8.99419H7.67551Z"
			fill="currentColor"
			stroke="currentColor"
			strokeWidth="1.40501"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12.3859 8.21621C13.4801 8.06242 14.3229 7.12331 14.3249 5.98667C14.3249 4.86643 13.5082 3.93689 12.4371 3.76123"
			stroke="currentColor"
			strokeWidth="1.40501"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M13.8295 10.8481C14.8896 11.006 15.6298 11.3778 15.6298 12.1433C15.6298 12.6703 15.2812 13.012 14.718 13.2259"
			stroke="currentColor"
			strokeWidth="1.40501"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
